module.exports = [{"name":"crimson","code":"#dc143c"},{"name":"tomato","code":"#ff6347"},{"name":"orange","code":"#ff6347"},{"name":"gold","code":"#ffa500"},{"name":"pink","code":"#ffc0cb"},{"name":"plum","code":"#dda0dd"},{"name":"tan","code":"#d2b48c"},{"name":"silver","code":"#c0c0c0"},{"name":"limegreen","code":"#32cd32"},{"name":"seagreen","code":"#2e8b57"},{"name":"darkcyan","code":"#008b8b"},{"name":"skyblue","code":"#87ceeb"},{"name":"royalblue","code":"#4169e1"},{"name":"black","code":"#111111"},{"name":"white","code":"#f8f8f8"}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/master/color.json
// module id = DRbb
// module chunks = 0